var _style, _g, _path, _defs, _circle, _path2, _defs2, _circle2, _path3, _defs3, _circle3, _path4, _defs4, _circle4, _path5, _defs5, _circle5, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 70.82",
    style: {
      enableBackground: "new 0 0 300 70.82"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#034EA2;}\n\t.st1{fill:#3B6232;}\n\t.st2{fill:#CDDCEC;}\n\t.st3{clip-path:url(#XMLID_00000057831240461218483770000004636328238727248804_);fill:#4088C8;}\n\t.st4{clip-path:url(#XMLID_00000057831240461218483770000004636328238727248804_);fill:#42568E;}\n\t.st5{fill:#F7FCFF;}\n\t.st6{clip-path:url(#XMLID_00000015331486406322390190000008255057746176332728_);fill:#4088C8;}\n\t.st7{clip-path:url(#XMLID_00000015331486406322390190000008255057746176332728_);fill:#42568E;}\n\t.st8{clip-path:url(#SVGID_00000181051027034844068940000004404384174121522352_);fill:#4088C8;}\n\t.st9{clip-path:url(#SVGID_00000181051027034844068940000004404384174121522352_);fill:#42568E;}\n\t.st10{clip-path:url(#XMLID_00000036247961007634467260000012203116856526588845_);fill:#4088C8;}\n\t.st11{clip-path:url(#XMLID_00000036247961007634467260000012203116856526588845_);fill:#42568E;}\n\t.st12{clip-path:url(#XMLID_00000039831284010700163500000007425114618956951455_);fill:#4088C8;}\n\t.st13{clip-path:url(#XMLID_00000039831284010700163500000007425114618956951455_);fill:#42568E;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.32,61.59h-3.21v8.88H14.1v-8.88h-3.27l-4.94,8.88H0l6.61-11.52l-6.2-10.52h5.38l4.94,8.91h3.37v-8.91 h5.01v8.91h3.27l4.97-8.91h5.38l-6.17,10.52l6.58,11.52h-5.89L22.32,61.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.22,65.74H40.99l-1.95,4.72h-5.23l9.82-22.04h5.04l9.85,22.04h-5.35L51.22,65.74z M49.62,61.87l-3.49-8.44 l-3.5,8.44H49.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.55,48.43v22.04H61.45V48.43h5.07v17.88h6.96V48.43h5.07v17.88h6.93V48.43H90.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.88,57.46c1.44,1.2,2.16,2.97,2.16,5.32c0,2.5-0.79,4.4-2.38,5.71c-1.59,1.31-3.82,1.97-6.69,1.97h-9.95 V48.43h5.07v7.24h5.6C109.38,55.67,111.44,56.27,112.88,57.46z M108.79,65.71c0.75-0.65,1.12-1.59,1.12-2.83 c0-2.29-1.41-3.43-4.22-3.43h-4.6v7.24h4.6C107.01,66.69,108.04,66.36,108.79,65.71z M117.84,48.43h5.07v22.04h-5.07V48.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.03,48.43v22.04H143V52.58h-7.56l-0.16,4.6c-0.11,3.13-0.36,5.66-0.76,7.6c-0.4,1.94-1.07,3.43-2,4.47 c-0.93,1.04-2.24,1.56-3.92,1.56c-0.69,0-1.53-0.12-2.52-0.35l0.32-4.31c0.27,0.08,0.58,0.13,0.91,0.13 c1.22,0,2.07-0.72,2.55-2.16c0.48-1.44,0.79-3.69,0.91-6.75l0.31-8.94H148.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.07,61.59h-3.53v8.88h-5.07V48.43h5.07v8.91h3.65l5.79-8.91h5.38l-7.21,10.64l7.43,11.4h-5.79 L162.07,61.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.33,48.43v22.04h-5.04V52.58h-7.56l-0.16,4.6c-0.11,3.13-0.36,5.66-0.76,7.6c-0.4,1.94-1.07,3.43-2,4.47 c-0.93,1.04-2.24,1.56-3.92,1.56c-0.69,0-1.53-0.12-2.52-0.35l0.32-4.31c0.27,0.08,0.58,0.13,0.91,0.13 c1.22,0,2.07-0.72,2.55-2.16c0.48-1.44,0.79-3.69,0.91-6.75l0.31-8.94H196.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.84,48.43h5.07v14.36l10.52-14.36h4.79v22.04h-5.04V56.14l-10.52,14.32h-4.82V48.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.74,70.47l-0.03-13.19l-6.49,10.86h-2.27l-6.49-10.61v12.94h-4.78V48.43h4.22l8.25,13.69l8.12-13.69h4.22 l0.03,22.04H247.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.93,65.74h-10.23l-1.95,4.72h-5.23l9.82-22.04h5.04l9.85,22.04h-5.35L272.93,65.74z M271.32,61.87 l-3.49-8.44l-3.5,8.44H271.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300,52.58h-7.05v17.88h-5.04V52.58h-7.02v-4.16H300V52.58z"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.8,38.82c1.15,0.32,3.03-0.36,3.86-1.05c1.71-1.44,1.4-3.69,0.02-5.15c-1.39-1.46-3.19-2.21-4.43-1.62 c-1.24,0.59-3.14,0.98-3.32,3.1c-0.17,1.96,0.46,2.19,1.47,3.2C108.41,38.31,109.8,38.82,109.8,38.82z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_60_",
    d: "M106.26,34.49c0.39-2.49,3.01-3.89,5.28-3.16c7.19,4.64-0.9,11.08-5.24,4.22 C106.3,35.55,106.16,35.15,106.26,34.49z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_60_",
    style: {
      overflow: "visible",
      fill: "#104572"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000001629819542348064410000011200513606991956116_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_60_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5013 -0.8653 0.8653 0.5013 25.7876 112.0358)",
    style: {
      clipPath: "url(#XMLID_00000001629819542348064410000011200513606991956116_)",
      fill: "#4088C8"
    },
    cx: 110.08,
    cy: 33.65,
    rx: 3.64,
    ry: 4.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5013 -0.8653 0.8653 0.5013 24.1004 108.6065)",
    style: {
      clipPath: "url(#XMLID_00000001629819542348064410000011200513606991956116_)",
      fill: "#42568E"
    },
    cx: 106.27,
    cy: 33.4,
    rx: 2.23,
    ry: 2.55
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 111.34,
    cy: 33.26,
    r: 0.29
  }))), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.2,26.85c-1.19-0.08-2.9,0.95-3.57,1.8c-1.39,1.75-0.64,3.9,1.01,5.05c1.65,1.15,3.57,1.53,4.67,0.7 c1.1-0.83,2.88-1.59,2.64-3.7c-0.23-1.95-0.89-2.06-2.08-2.85C136.67,27.07,135.2,26.85,135.2,26.85z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    d: "M139.54,30.39c0.11,2.51-2.18,4.41-4.54,4.15c-7.97-3.11-1.33-11.04,4.29-5.18 C139.29,29.36,139.51,29.73,139.54,30.39z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_58_",
    style: {
      overflow: "visible",
      fill: "#104572"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000137109138311437618760000003464310985983036306_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_58_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3183 -0.948 0.948 0.3183 62.3652 150.6848)",
    style: {
      clipPath: "url(#XMLID_00000137109138311437618760000003464310985983036306_)",
      fill: "#4088C8"
    },
    cx: 135.96,
    cy: 31.98,
    rx: 3.64,
    ry: 4.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3183 -0.948 0.948 0.3183 65.4398 153.927)",
    style: {
      clipPath: "url(#XMLID_00000137109138311437618760000003464310985983036306_)",
      fill: "#42568E"
    },
    cx: 139.75,
    cy: 31.46,
    rx: 2.23,
    ry: 2.55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 134.81,
    cy: 32.61,
    r: 0.29
  }))), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.47,31.91c0.63-1.01,0.15-2.85-0.28-3.85c-0.88-2.05-3.13-2.41-4.93-1.5s-3,2.63-2.79,3.99 s0.01,3.08,1.98,3.86c1.83,0.72,2.87,0.17,4.13-0.51C121.84,33.23,122.47,31.91,122.47,31.91z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M117.29,26.78c-2.3,1.03-3.26,4.25-1.88,6.36c1.62,2.47,5.79,0.95,6.78-1.27 C123.61,28.44,120.69,25.28,117.29,26.78"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#104572"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176740628203336178250000001891727188313096109_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9154 -0.4026 0.4026 0.9154 -1.6439 50.0552)",
    style: {
      clipPath: "url(#SVGID_00000176740628203336178250000001891727188313096109_)",
      fill: "#4088C8"
    },
    cx: 118.23,
    cy: 28.94,
    rx: 4.08,
    ry: 3.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9154 -0.4026 0.4026 0.9154 -0.8324 50.9175)",
    style: {
      clipPath: "url(#SVGID_00000176740628203336178250000001891727188313096109_)",
      fill: "#42568E"
    },
    cx: 120.69,
    cy: 27.44,
    rx: 2.68,
    ry: 2.35
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 118.5,
    cy: 31.44,
    r: 0.29
  }))), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M123.43,31.97c-0.92,0.74-1.44,2.74-1.19,3.79c0.25,1.05,2.12,3.31,4.09,3.04c1.97-0.26,3.83-1.29,4.09-2.65 c0.25-1.35,0.31-3.15-1.44-4.01c-1.74-0.86-1.43-1.26-2.83-1.04C124.75,31.33,123.43,31.97,123.43,31.97z"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    d: "M128.07,37.96c6.09-2.2-0.6-9.28-4.39-5.57C120.47,35.14,124.56,39.95,128.07,37.96"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_46_",
    style: {
      overflow: "visible",
      fill: "#104572"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000083078716901172217900000001167218660188914841_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_46_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9154 -0.4026 0.4026 0.9154 -3.5398 54.1471)",
    style: {
      clipPath: "url(#XMLID_00000083078716901172217900000001167218660188914841_)",
      fill: "#4088C8"
    },
    cx: 127.02,
    cy: 35.49,
    rx: 2.95,
    ry: 2.71
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9154 -0.4026 0.4026 0.9154 -2.3509 54.4675)",
    style: {
      clipPath: "url(#XMLID_00000083078716901172217900000001167218660188914841_)",
      fill: "#42568E"
    },
    cx: 128.37,
    cy: 32.83,
    rx: 1.68,
    ry: 1.47
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 125.75,
    cy: 33.07,
    r: 0.29
  }))), /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M130.2,28.86c0.88-0.8,1.27-2.82,0.96-3.85s-2.31-3.17-4.26-2.79s-3.75,1.52-3.92,2.89 c-0.17,1.37-0.12,3.16,1.67,3.91c1.79,0.75,1.51,1.18,2.89,0.87C128.92,29.57,130.2,28.86,130.2,28.86z"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    d: "M125.2,23.15c-5.94,2.56,1.16,9.22,4.71,5.3C132.96,25.51,128.58,20.96,125.2,23.15"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_44_",
    style: {
      overflow: "visible",
      fill: "#104572"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000114038826085440904130000009098126533965730455_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_44_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8895 -0.4569 0.4569 0.8895 2.2904 60.5839)",
    style: {
      clipPath: "url(#XMLID_00000114038826085440904130000009098126533965730455_)",
      fill: "#4088C8"
    },
    cx: 126.4,
    cy: 25.56,
    rx: 2.95,
    ry: 2.71
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8895 -0.4569 0.4569 0.8895 0.9045 60.3417)",
    style: {
      clipPath: "url(#XMLID_00000114038826085440904130000009098126533965730455_)",
      fill: "#42568E"
    },
    cx: 125.21,
    cy: 28.3,
    rx: 1.68,
    ry: 1.47
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 127.81,
    cy: 27.9,
    r: 0.29
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.86,40.15c2-0.85,3.94-1.12,6.03-1.02c1.33-0.04,2.74,0.46,4.07,0.13c0.66-0.16,1.28-0.54,1.9-0.79 c1.31-0.42,2.62-0.53,4-0.52c0.05,0,0.1,0.05,0.09,0.11c-0.2,0.33-0.53,0.58-0.83,0.82c-0.88,0.58-1.91,1.02-2.97,1.07 c-0.71,0.03-1.43-0.16-2.11-0.11c-2.04,0.24-3.97,1.3-6.07,1.24c-1.37-0.01-2.75-0.17-4.12-0.75 C89.78,40.3,89.78,40.18,89.86,40.15L89.86,40.15z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.48,36.13c1.54,0.57,2.65,1.42,3.54,2.67c0.75,0.67,1.61,1.73,2.65,2.06c1.08,0.21,2.16,0.1,3.1,0.84 c0.45,0.31,0.89,0.64,1.26,1.15c0.04,0.05,0.03,0.12-0.02,0.15c-1.16,0.24-2.29,0.02-3.27-0.56c-0.45-0.32-0.83-0.79-1.3-1.06 c-0.98-0.6-2.19-0.39-3.22-1c-1.46-0.93-2.39-2.42-2.87-4.14C118.32,36.18,118.4,36.1,118.48,36.13L118.48,36.13z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.56,37.81c1.06-0.55,1.92-0.58,2.85-0.1c0.57,0.18,1.03,0.95,1.67,0.92c0.31,0,0.66-0.24,0.97-0.31 c0.31-0.07,0.59,0.04,0.86,0.15c0.29,0.15,0.53,0.31,0.86,0.63c0.05,0.04,0.05,0.12,0.01,0.17c-0.51,0.61-1.29,0.81-1.96,0.54 c-0.3-0.17-0.56-0.5-0.85-0.61c-0.29-0.12-0.61-0.08-0.95,0.02c-0.65,0.21-1.29,0.21-1.92,0.06c-0.59-0.23-1.14-0.58-1.59-1.3 C130.48,37.93,130.5,37.85,130.56,37.81L130.56,37.81z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.35,38.67c-1.74,0.39-3.32,0.14-4.83-0.61c-1-0.37-1.8-1.33-2.87-1.55c-1.08-0.13-2.23-0.02-3.15-0.79 c-0.45-0.32-0.88-0.69-1.21-1.23c-0.04-0.06,0-0.16,0.08-0.16c1.16-0.09,2.19,0.09,3.16,0.64c0.45,0.3,0.84,0.76,1.32,0.98 c1.48,0.59,3.23,0.2,4.73,0.83c0.99,0.38,1.94,0.87,2.82,1.7C151.46,38.55,151.43,38.65,151.35,38.67L151.35,38.67z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.72,32.53c-2.13,1.13-4.4,1.48-6.73,1.33c-1.52,0-3.04-0.62-4.56-0.49c-1.5,0.23-3.03,0.69-4.56,0.24 c-0.75-0.15-1.5-0.39-2.21-0.79c-0.07-0.04-0.06-0.16,0.02-0.18c2.35-0.81,4.47-0.42,6.76,0.15c2.25,0.06,4.44-0.89,6.71-0.87 c1.49-0.02,2.99,0.06,4.55,0.44C158.78,32.37,158.8,32.49,158.72,32.53L158.72,32.53z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.44,27.71c-0.55,1.12-1.34,1.69-2.44,1.82c-0.63,0.18-1.46-0.22-2.05,0.12 c-0.29,0.15-0.53,0.52-0.82,0.73c-0.29,0.2-0.64,0.21-0.99,0.2c-0.35-0.04-0.73-0.13-1.1-0.42c-0.05-0.04-0.06-0.12-0.02-0.18 c0.27-0.39,0.54-0.59,0.82-0.77c0.28-0.15,0.56-0.3,0.9-0.27c0.33,0.03,0.72,0.22,1.05,0.17c0.33-0.04,0.6-0.23,0.85-0.5 c0.47-0.52,1.01-0.87,1.63-1.11c0.62-0.16,1.29-0.21,2.11,0.06C148.44,27.57,148.47,27.64,148.44,27.71L148.44,27.71z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.53,16.42c0.44,1.23,0.24,2.3-0.5,3.23c-0.35,0.62-1.26,0.93-1.51,1.61c-0.13,0.33-0.09,0.79-0.21,1.15 c-0.13,0.36-0.41,0.62-0.73,0.84c-0.33,0.2-0.72,0.36-1.21,0.33c-0.07,0-0.12-0.06-0.12-0.13c0.03-0.5,0.15-0.81,0.27-1.14 c0.15-0.29,0.28-0.59,0.56-0.78c0.28-0.19,0.71-0.31,0.94-0.58c0.23-0.26,0.32-0.61,0.33-0.98c0.01-0.73,0.17-1.38,0.45-2.02 c0.34-0.58,0.78-1.12,1.55-1.58C136.42,16.32,136.51,16.35,136.53,16.42L136.53,16.42z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.93,0.06c0.59,3.6,0.32,7.28-0.58,10.8c-0.75,3.56-2.69,6.71-3.69,10.17c0,0-0.42-0.5-0.42-0.5 c1.45-0.81,2.41-2.52,3.47-3.82c1.08-1.49,2.02-3.08,3.13-4.57c0.05-0.08,0.18-0.03,0.17,0.07c-0.67,3.74-2.6,7.99-6.61,9.05 c-0.2,0.06-0.41-0.06-0.45-0.26c2.19-4.92,2.32-10.5,3.61-15.71c0.37-1.73,0.75-3.46,1.2-5.22 C132.76-0.04,132.91-0.04,132.93,0.06L132.93,0.06z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.91,2.09c0.31,1.59-0.2,2.99-1.2,4.11c-0.56,0.77-1.63,1.13-2.12,1.95c-0.26,0.38-0.34,0.94-0.6,1.36 c-0.24,0.43-0.65,0.71-1.06,0.96c-0.42,0.24-0.9,0.41-1.47,0.44c-0.06,0-0.11-0.04-0.12-0.11c0.11-0.58,0.4-0.98,0.64-1.38 c0.49-0.91,1.39-1.11,2.15-1.65c0.88-0.93,0.91-2.59,1.69-3.68c0.5-0.73,1.06-1.42,1.91-2.07C137.8,1.99,137.9,2.02,137.91,2.09 L137.91,2.09z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.64,2.22c1.61,1.99,2.52,4.27,2.93,6.73c0.37,1.59,0.13,3.31,0.58,4.88c0.81,2.01,1.45,3.89,0.78,6.1 c-0.13,0.42-0.31,0.82-0.53,1.19c-0.03,0.05-0.09,0.06-0.13,0.03c-0.03-0.02-0.04-0.04-0.05-0.07c-0.68-2.5-0.73-4.61-0.65-7.14 c-0.42-2.38-1.89-4.46-2.43-6.81c-0.38-1.55-0.68-3.14-0.68-4.85C124.47,2.2,124.58,2.15,124.64,2.22L124.64,2.22z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.2,2.74c1.26,2.91,0.48,6.37-1.38,8.84c-0.38,0.65-1.37,0.16-1.81-0.09c-1.71-1.17-3.73-2.32-4.39-4.41 c-0.31-0.77-0.51-1.58-0.52-2.46c0-0.05,0.04-0.1,0.1-0.1c1.26,1.07,2.14,2.41,2.9,3.83c0.43,1.03,1,2.22,2.18,2.5 c0.23,0.07,0.73,0.08,0.84-0.07c0,0-0.32,0.29-0.32,0.29c0.71-2.86,1.32-5.44,2.23-8.32C129.04,2.68,129.17,2.66,129.2,2.74 L129.2,2.74z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.07,13.29c1.04,0.73,1.51,1.58,1.56,2.72c0.13,0.65-0.32,1.48,0.01,2.1c0.14,0.31,0.51,0.56,0.72,0.85 c0.2,0.29,0.22,0.64,0.23,0.99c-0.02,0.36-0.07,0.72-0.32,1.14c-0.04,0.06-0.11,0.08-0.17,0.05c-0.43-0.23-0.66-0.52-0.86-0.81 c-0.18-0.3-0.34-0.61-0.32-0.96c0.02-0.36,0.21-0.76,0.17-1.1c-0.03-0.34-0.21-0.64-0.47-0.92c-0.5-0.53-0.82-1.14-1-1.82 c-0.1-0.67-0.08-1.38,0.3-2.19C123.93,13.27,124.01,13.25,124.07,13.29L124.07,13.29z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.66,12.46c2.87,0.82,5.47,2.35,7.67,4.34c2.31,1.86,3.75,4.56,6.02,6.45c0,0-0.68,0.16-0.68,0.16 c-0.09-1.02-1.17-2.66-1.61-3.64c0,0-1.04-1.88-1.04-1.88c-0.35-0.64-0.72-1.28-1.02-1.99c-0.02-0.05,0-0.1,0.05-0.13 c0.72,0.29,1.31,0.91,1.89,1.42c1.68,1.7,3.13,3.93,2.49,6.47c-0.05,0.2-0.25,0.32-0.45,0.27c-2.8-3.54-6.6-5.11-10.17-8.36 c-1.1-0.93-2.18-1.89-3.23-2.95C108.51,12.56,108.57,12.43,108.66,12.46L108.66,12.46z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.87,9.99c1.35,0.22,2.22,1.03,2.65,2.19c0.36,0.66,0.13,1.62,0.58,2.24c0.19,0.31,0.62,0.54,0.86,0.85 c0.25,0.31,0.3,0.7,0.33,1.09c0.01,0.39-0.06,0.81-0.3,1.24c-0.03,0.06-0.11,0.08-0.17,0.05c-0.44-0.27-0.65-0.58-0.88-0.87 c-0.58-0.72-0.27-1.33-0.37-2.11c-0.1-0.35-0.34-0.63-0.66-0.85c-0.61-0.43-1.09-0.93-1.51-1.52c-0.33-0.61-0.59-1.27-0.66-2.18 C111.74,10.04,111.8,9.98,111.87,9.99L111.87,9.99z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.33,18.71c2.08-0.48,4.06-0.25,5.97,0.5c1.27,0.38,2.36,1.36,3.67,1.64c0.64,0.16,1.37,0.09,2.04,0.24 c1,0.22,1.91,0.83,2.64,1.55c0.24,0.27,0.46,0.57,0.62,0.89c0.04,0.07-0.03,0.16-0.11,0.14c-1.32-0.23-2.54-0.55-3.71-1.18 c-0.54-0.35-1.07-0.83-1.67-1.09c-1.85-0.65-3.94-0.28-5.82-0.88c-1.25-0.37-2.48-0.83-3.66-1.63 C107.23,18.84,107.25,18.72,107.33,18.71L107.33,18.71z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.3,15.93c2.63,0.02,4.93,1.89,5.95,4.23c0,0,0.11,0.26,0.11,0.26c0.04,0.36-0.28,0.62-0.42,0.75 c-1.03,0.68-2.15,1.08-3.29,1.57c-1.33,0.31-2.67-0.01-3.83-0.74c-0.05-0.03-0.06-0.1-0.03-0.14c1.22-0.54,2.46-0.67,3.73-0.59 c0.94,0.2,2.27,0.42,2.76-0.62c0.04-0.09,0.05-0.27,0-0.21l0.11,0.39c-1.96-1.44-3.57-2.79-5.17-4.73 C109.17,16.03,109.21,15.92,109.3,15.93L109.3,15.93z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.11,23.33c0.96-0.58,1.74-0.64,2.58-0.15c0.51,0.18,0.88,0.95,1.46,0.94c0.28,0.01,0.61-0.2,0.91-0.25 c0.29-0.05,0.54,0.09,0.79,0.25c0.14,0.1,0.82,0.68,0.61,0.97c-0.35,0.27-0.65,0.35-0.95,0.4c-0.29,0.02-0.57,0.03-0.81-0.15 c-0.24-0.18-0.43-0.53-0.69-0.65c-0.51-0.28-1.2,0.23-1.73,0.15c-0.97,0.04-1.63-0.37-2.21-1.33 C115.03,23.45,115.05,23.37,115.11,23.33L115.11,23.33z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.32,12.27c-1.72,4.91-3.86,9.63-6.25,14.24c0,0-1.26-1.3-1.26-1.3c2.4-1.14,4.97-2.29,6.84-4.21 c3.22-2.38,6.64-4.26,10-6.41c0.26-0.14,0.59-0.29,0.89-0.38c0.32-0.18,0.64-0.36,1-0.62c1.78-1.26,5.38-3.83,7.15-5.12 c0.96-0.76,2.64-1.81,3.39-2.74c0.02-0.05,0.1-0.09,0.14-0.05c-0.26,1.36-1.86,2.66-2.78,3.68c-2.2,2.08-4.48,4.02-7.17,5.46 c-0.42,0.22-0.97,0.47-1.5,0.58c-3.73,1.02-7.13,3.48-9.88,6.1c0,0-0.35,0.39-0.35,0.39c-1.71,2.39-4.42,3.67-6.91,5.06 c-0.46,0.24-1.03,0.06-1.27-0.4c-0.15-0.29-0.13-0.62,0.01-0.89c2.3-4.65,4.85-9.16,7.79-13.45 C145.22,12.1,145.36,12.17,145.32,12.27L145.32,12.27z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.19,3.93c-0.77,2.78-2.08,5.2-3.78,7.46c-1.03,1.53-2.55,2.77-3.39,4.43c-0.74,1.7-1.25,3.52-2.48,4.97 c-0.55,0.75-1.15,1.46-1.83,2.15c-0.04,0.04-0.1,0.04-0.13,0c0.1-1.93,1.05-3.72,2.12-5.28c0.58-0.74,1.31-1.38,1.83-2.14 c1.49-2.35,2.18-5.16,3.82-7.45c1.06-1.53,2.22-2.98,3.7-4.24C155.1,3.78,155.21,3.84,155.19,3.93L155.19,3.93z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.29,6.34c-0.51,1.75-1.69,3.01-3.23,3.81c-0.93,0.6-2.2,0.64-3.09,1.3c-0.88,0.76-1.53,1.64-2.83,1.76 c-0.56,0.1-1.15,0.1-1.76-0.06c-0.08-0.02-0.1-0.12-0.05-0.17c1.3-1.48,2.65-1.71,4.35-2.04c1.42-0.73,2.2-2.35,3.54-3.21 c0.86-0.6,1.77-1.13,2.93-1.5C160.23,6.19,160.31,6.26,160.29,6.34L160.29,6.34z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.78,11.68c-1.44,1.53-3.26,2.36-5.26,2.66c-1.27,0.3-2.68-0.03-3.93,0.37c-1.21,0.48-2.42,1.19-3.81,0.97 c-0.66-0.03-1.33-0.18-1.99-0.47c-0.07-0.03-0.08-0.14-0.01-0.18c1.2-0.66,2.41-0.99,3.74-1.03c0.64,0.04,1.32,0.19,1.96,0.14 c1.89-0.33,3.48-1.66,5.35-2.1c1.23-0.31,2.47-0.55,3.87-0.52C169.79,11.51,169.84,11.61,169.78,11.68L169.78,11.68z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.13,20.4c-1.39,1.58-3.2,2.46-5.2,2.8c-1.27,0.32-2.68,0.01-3.93,0.4c-1.22,0.48-2.45,1.18-3.83,0.92 c-0.66-0.05-1.33-0.22-1.98-0.54c-0.07-0.03-0.07-0.14-0.01-0.18c1.23-0.61,2.43-0.9,3.75-0.92c0.64,0.04,1.31,0.21,1.95,0.15 c1.89-0.32,3.46-1.69,5.31-2.16c1.22-0.34,2.45-0.61,3.85-0.64C157.13,20.23,157.19,20.34,157.13,20.4L157.13,20.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGreen);
export default __webpack_public_path__ + "static/media/logo_green.4d433aed85e70f5e281464555de92571.svg";
export { ForwardRef as ReactComponent };